// src/scripts/fluco-lib/events.js
var EVENTS = {
  SHOPIFY_BLOCK_SELECT: "shopify:block:select",
  SHOPIFY_BLOCK_DESELECT: "shopify:block:deselect",
  SHOPIFY_SECTION_DESELECT: "shopify:section:deselect",
  SHOPIFY_SECTION_SELECT: "shopify:section:select",
  SHOPIFY_SECTION_LOAD: "shopify:section:load",
  SHOPIFY_SECTION_UNLOAD: "shopify:section:unload",
  SWIPER_JS_LOADED: "fluco_section:swiper_js_loaded",
  COUNTDOWN_TIMER_COMPLETED_EVENT: "fluco_section:countdown_timer_completed"
};
var events_default = EVENTS;

// src/scripts/sections/countdown-banner-1.js
var { SHOPIFY_BLOCK_SELECT, SHOPIFY_BLOCK_DESELECT } = events_default;
var CountdownBanner1 = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      section: ".fluco-section",
      timerGroup: "[js-timer-group]",
      completedContentBlock: "[js-completed-content-block]"
    };
  }
  connectedCallback() {
    this.eventController = new AbortController();
    this.eventOptions = { signal: this.eventController.signal };
    this.sectionEl = this.closest(this.selectors.section);
    this.timerGroup = this.querySelector(this.selectors.timerGroup);
    this.completedContentBlock = this.querySelector(
      this.selectors.completedContentBlock
    );
    if (window.Shopify.designMode) {
      this.setAttribute("data-theme-editor", "true");
      this.sectionEl.addEventListener(
        SHOPIFY_BLOCK_SELECT,
        (event) => this.handleBlockSelected(event.detail.blockId),
        this.eventOptions
      );
      this.sectionEl.addEventListener(
        SHOPIFY_BLOCK_DESELECT,
        (event) => this.handleBlockDeselected(event.detail.blockId),
        this.eventOptions
      );
    }
  }
  disconnectedCallback() {
    this.eventController.abort();
  }
  handleBlockSelected(blockId) {
    if (this.completedContentBlock && this.completedContentBlock.getAttribute("data-block-id") === blockId && this.timerGroup.getAttribute("data-replace-content-when-completed") === "true") {
      this.timerGroup.setAttribute("data-editor-content-override", "true");
    }
  }
  handleBlockDeselected(blockId) {
    if (this.completedContentBlock.getAttribute("data-block-id") === blockId) {
      this.timerGroup.setAttribute("data-editor-content-override", "false");
    }
  }
};
if (!customElements.get("fluco-local-v4-countdown-banner-1")) {
  customElements.define("fluco-local-v4-countdown-banner-1", CountdownBanner1);
}
